import styled from 'styled-components';
import { Modal, Spin } from 'antd';
import { blueDark01 } from '../../../../../styles/colors';

export const NotificationModalContainer = styled(Modal)`
    width: 50vw !important;
    .ant-modal-content {
        border-radius: 8px;
        padding: 32px;
    }
`;

export const NotificationModalSpin = styled(Spin)`
    width: 100%;
`;

export const ModalBody = styled.div`
    margin-top: 16px;
    margin-bottom: 24px;
`;

export const ModalDescription = styled.p`
    font-size: 14px;
    color: ${blueDark01};
    margin-bottom: 20px;
`;

export const CheckboxItem = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 14px;
`;

export const CheckboxLabel = styled.span`
    font-size: 14px;
    color: ${blueDark01};
`;

export const ModalDivider = styled.div`
    height: 1px;
    background: #e8e8e8;
    margin: 8px 0 20px 0;
`;

export const FooterRow = styled.div`
    display: flex;
    justify-content: flex-end;
`;
